"use client";

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DESKTOP_QUERY } from "@/lib/breakpoints";
gsap.registerPlugin(ScrollTrigger);
type StaggerAnimationOptions = {
  y?: number;
  duration?: number;
  stagger?: number;
  delay?: number;
};
export const useGsapStaggerAnimation = (ref, options) => {
  const $ = _c(12);
  let t0;
  if ($[0] !== options?.delay || $[1] !== options?.duration || $[2] !== options?.stagger || $[3] !== options?.y || $[4] !== ref) {
    t0 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      const cards = Array.from(element.children);
      if (!cards.length) {
        return;
      }
      const media = gsap.matchMedia();
      media.add(`${DESKTOP_QUERY} and (prefers-reduced-motion: no-preference)`, () => {
        gsap.set(cards, {
          opacity: 0,
          y: options?.y ?? 60
        });
        gsap.to(cards, {
          opacity: 1,
          y: 0,
          duration: options?.duration ?? 1,
          stagger: {
            each: options?.stagger ?? 0.18
          },
          delay: options?.delay ?? 0,
          ease: "power4.out",
          clearProps: "transform",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            once: true
          }
        });
      });
      return () => media.revert();
    };
    $[0] = options?.delay;
    $[1] = options?.duration;
    $[2] = options?.stagger;
    $[3] = options?.y;
    $[4] = ref;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const t1 = options?.y;
  const t2 = options?.duration;
  const t3 = options?.stagger;
  const t4 = options?.delay;
  let t5;
  if ($[6] !== ref || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = [ref, t1, t2, t3, t4];
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useLayoutEffect(t0, t5);
};